/**
 * The body of the email `send_quotation` sends — the part after "Dear <customer>,".
 *
 * Measured in the bench's Email Queue (2026-09-15): the method's `note` IS that body, and an
 * empty note produces the server's own "Please find your quotation attached." So the payment
 * terms the purchaser picked go here, stated as a line the customer reads — this is "the terms
 * message passed with the quotation" (Akhil), not a template name on a form nobody sees.
 */
export function quotationSendNote(quotation: { payment_terms_template: string }): string {
  const terms = quotation.payment_terms_template.trim()
  const lines = ['Please find your quotation attached.']
  if (terms !== '') lines.push('', `Payment terms: ${terms}`)
  return lines.join('\n')
}
